import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "popup-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "title-section flex justify-between" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = {
  key: 0,
  class: "title-icon"
}
const _hoisted_6 = { class: "popup-body" }
const _hoisted_7 = {
  key: 0,
  class: "popup-footer"
}

import {
  Dialog,
  DialogOverlay,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue'
import { useSlots } from '@vue/runtime-dom'
import { computed } from 'vue'

interface PopupEmits {
  (e: 'close', value: boolean): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Popup',
  props: {
  open: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
  width: {
    type: String,
    default: '410',
  },
  canClose: {
    type: Boolean,
    default: true,
  },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const props = __props
const maxWidth = computed(() => `${props.width}px`)
const emit = __emit

const slots = useSlots()

const close = () => {
  if (props.canClose) {
    emit('close', false)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: __props.open
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "popup fixed inset-0",
        onClose: close
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
              ]),
              _: 1
            }),
            _hoisted_2,
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to": "opacity-100 translate-y-0 sm:scale-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "popup-box",
                  style: _normalizeStyle({ maxWidth: maxWidth.value })
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      (_unref(slots)['icon'])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _renderSlot(_ctx.$slots, "icon")
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.$slots.title)
                        ? _renderSlot(_ctx.$slots, "title", { key: 1 })
                        : (__props.title)
                          ? (_openBlock(), _createBlock(_unref(DialogTitle), {
                              key: 2,
                              as: "h3",
                              class: "text-lg leading-6 font-medium text-gray-900"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(__props.title), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                    ]),
                    (__props.canClose)
                      ? (_openBlock(), _createBlock(_component_SvgIcon, {
                          key: 0,
                          class: "cursor-pointer text-gray-900",
                          icon: 'close',
                          "inherit-fill": true,
                          height: "24",
                          onClick: close
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _renderSlot(_ctx.$slots, "default")
                  ]),
                  (_unref(slots)['footer'])
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _renderSlot(_ctx.$slots, "footer")
                      ]))
                    : _createCommentVNode("", true)
                ], 4)
              ]),
              _: 3
            })
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})